module.exports = __webpack_public_path__ + "img/search-questions.dedf6a0a.svg";